/**
 * 配置编辑框的公共参数
//  */
import Vue from "vue";
import VueStorage from "vue-ls";
import httpUrl from "./../utils/httpUrl";
Vue.use(VueStorage, {
  namespace: "pro__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
});
export default {
  menus: [
    "head",
    "bold",
    "fontSize",
    "fontName",
    "italic",
    "underline",
    "strikeThrough",
    "foreColor",
    "backColor",
    "link",
    "list",
    "justify",
    "quote",
    "image",
    "table",
    "video",
    "code",
    "undo",
    "redo",
    "unlink",
    "table",
    "emotion",
  ],
  picUrl: "common/upload",
  data: function(newWang) {
    return (
      (newWang.customConfig.menus = this.menus),
      (newWang.customConfig.uploadImgServer =
        httpUrl.baseUrl.web + this.picUrl), // 上传图片到服务器
      (newWang.customConfig.uploadImgHeaders = {
        Authorization: `Bearer ${Vue.ls.get("Token")}`,
        Lang: "ZH",
      }),
      (newWang.customConfig.uploadFileName = "file"),
      (newWang.customConfig.uploadImgHooks = {
        customInsert: function(insertImg, result) {
          // insertImg, result, editor
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          var url = result.url;
          insertImg(url);

          // result 必须是一个 JSON 格式字符串！！！否则报错
        },
      })
    );
  },
};
